import React, { useEffect, useState, useRef } from "react";
import { ModalCrosSvg, ExcelSvg, ImageCroseSvg } from "../../../images/Svgs";
import { toast } from "react-toastify";
import { useDragDrop } from "../../../utils/common";
import { ImportRoutine } from "../../../API/routine";
const ImportSchedule = ({ onModalClose,EventId,fetchRoutine}) => {
  const imageInputRef = useRef(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [dragActive, setDragActive] = useState(false);
  const [submiting,setSubmiting]=useState(false);
  const handleImageUploadClick = () => {
    imageInputRef.current.click();
  };
  const handleFile = (file) => {
    if (file) {
      const fileType = file.type;
      if (fileType === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
        setSelectedImage(file);
      } else {
        toast.error("Please upload a valid Excel file (.xlsx)");
      }
    }
  };
  //for drag drop file
  const { handleDragOver, handleDragLeave, handleDrop } = useDragDrop(
    handleFile,
    setDragActive,
    setDragActive,
    handleFile
  );
    const handleSubmit = async (e) => {
      setSubmiting(true)
      e.preventDefault();
        try {
          let formData = new FormData();
            formData.append("event_id",EventId);
            formData.append("import_file", selectedImage || null);
          const response = await ImportRoutine(formData);
          if (response?.status) {
            toast.success(response.message || "success !");
            fetchRoutine();
            onModalClose(false);
          } else {
            toast.error(response.message);
          }
          setSubmiting(false);
        } catch (error) {
          setSubmiting(false);
          console.error("Error during login request:", error); // Handle any other errors
        }
    };
  return (
    <div className="modal-overlay">
      <div className="modal fade show">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Import Schedule
              </h5>
              <button
                type="button"
                className="close"
                onClick={() => onModalClose(false)}
              >
                <ModalCrosSvg />
              </button>
            </div>
            <div className="modal-body">
              <div className="mt-3">
                <div
                  className="event_file"
                  onDragOver={handleDragOver}
                  onDragLeave={handleDragLeave}
                  onDrop={handleDrop}
                >
                  <div className="upload-btn-wrapper">
                    <button
                      className="vitalu_cont"
                      onClick={handleImageUploadClick}
                    >
                      <div className="upload_icon">
                        <ExcelSvg />
                      </div>
                      <div className="vital_text_png">
                        {/* <span>Click to upload Event Image</span> or drag and drop */}
                        <p>
                          <span>Click to upload Excel File</span> or drag and
                          drop
                        </p>
                      </div>
                    </button>
                    <input
                      type="file"
                      className="d-none"
                      id="excelInput"
                      accept=".xls,.xlsx"
                      ref={imageInputRef}
                      name="image"
                      onChange={(e) => handleFile(e.target.files[0])}
                    />
                    {/* {eventError.event_img && (
                      <div className="text-danger">{eventError.event_img}</div>
                    )} */}
                  </div>
                  {selectedImage && (
                    <>
                      <h2 className="inter pb-1">Uploaded Excel Files</h2>
                      <div className="sample_file_icon">
                        <div className="sample_file">
                          <p className="inter">{selectedImage.name}</p>
                        </div>
                        <div
                          className="sample_file"
                          onClick={() => {
                            setSelectedImage(null);
                            if (imageInputRef.current) {
                              imageInputRef.current.value = "";
                            }
                          }}
                        >
                          <ImageCroseSvg />
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
              <br />
              {/* Buttons */}
              <div className="d-flex justify-content-end gap-2 mb-3">
                <button
                  type="button"
                  className="btn btn-light"
                  onClick={() => onModalClose(false)}
                >
                  Cancel
                </button>
                <button type="submit" className="btn btn-dark" disabled={!selectedImage || submiting}  onClick={(e) => handleSubmit(e)}>
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImportSchedule;
